module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-spinner",
    class: {
      'no-z-index': this.display === 'inline'
    },
    style: ({
      'color': this.color
    })
  }, [_c('img', {
    staticClass: "spinner",
    attrs: {
      "src": _vm.spinner,
      "alt": "UNOapp logo, two half-circle arrows pointing in the same direction laid on a circle, spinning"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-383825de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/LoadingScreen.vue
// module id = 702
// module chunks = 0